export default "__VITE_ASSET__C6$y5Luv__"